/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightCheckoutFare } from "./FlightCheckoutFare";
import {
  FlightCheckoutFareFromJSON,
  FlightCheckoutFareFromJSONTyped,
  FlightCheckoutFareToJSON,
  FlightCheckoutFareToJSONTyped,
} from "./FlightCheckoutFare";
import type { FlightCommercialQuoteEvidence } from "./FlightCommercialQuoteEvidence";
import {
  FlightCommercialQuoteEvidenceFromJSON,
  FlightCommercialQuoteEvidenceFromJSONTyped,
  FlightCommercialQuoteEvidenceToJSON,
  FlightCommercialQuoteEvidenceToJSONTyped,
} from "./FlightCommercialQuoteEvidence";
import type { FlightSelectedBag } from "./FlightSelectedBag";
import {
  FlightSelectedBagFromJSON,
  FlightSelectedBagFromJSONTyped,
  FlightSelectedBagToJSON,
  FlightSelectedBagToJSONTyped,
} from "./FlightSelectedBag";
import type { FlightObservedItinerary } from "./FlightObservedItinerary";
import {
  FlightObservedItineraryFromJSON,
  FlightObservedItineraryFromJSONTyped,
  FlightObservedItineraryToJSON,
  FlightObservedItineraryToJSONTyped,
} from "./FlightObservedItinerary";
import type { FlightPassengerComposition } from "./FlightPassengerComposition";
import {
  FlightPassengerCompositionFromJSON,
  FlightPassengerCompositionFromJSONTyped,
  FlightPassengerCompositionToJSON,
  FlightPassengerCompositionToJSONTyped,
} from "./FlightPassengerComposition";
import type { FlightSelectedSeat } from "./FlightSelectedSeat";
import {
  FlightSelectedSeatFromJSON,
  FlightSelectedSeatFromJSONTyped,
  FlightSelectedSeatToJSON,
  FlightSelectedSeatToJSONTyped,
} from "./FlightSelectedSeat";
import type { FlightCheckoutDisclosure } from "./FlightCheckoutDisclosure";
import {
  FlightCheckoutDisclosureFromJSON,
  FlightCheckoutDisclosureFromJSONTyped,
  FlightCheckoutDisclosureToJSON,
  FlightCheckoutDisclosureToJSONTyped,
} from "./FlightCheckoutDisclosure";
import type { FlightTravelerRequiredField } from "./FlightTravelerRequiredField";
import {
  FlightTravelerRequiredFieldFromJSON,
  FlightTravelerRequiredFieldFromJSONTyped,
  FlightTravelerRequiredFieldToJSON,
  FlightTravelerRequiredFieldToJSONTyped,
} from "./FlightTravelerRequiredField";
import type { FlightCheckoutPrice } from "./FlightCheckoutPrice";
import {
  FlightCheckoutPriceFromJSON,
  FlightCheckoutPriceFromJSONTyped,
  FlightCheckoutPriceToJSON,
  FlightCheckoutPriceToJSONTyped,
} from "./FlightCheckoutPrice";

/**
 *
 * @export
 * @interface FlightBookingHandoffQuote
 */
export interface FlightBookingHandoffQuote {
  /**
   *
   * @type {Array<FlightSelectedBag>}
   * @memberof FlightBookingHandoffQuote
   */
  selectedBags?: Array<FlightSelectedBag>;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  bagSelectionDigest?: string;
  /**
   * Bag choices are unpriced drafts and cannot be purchased yet.
   * @type {boolean}
   * @memberof FlightBookingHandoffQuote
   */
  bagPricingRequired?: boolean;
  /**
   *
   * @type {Array<FlightSelectedSeat>}
   * @memberof FlightBookingHandoffQuote
   */
  selectedSeats?: Array<FlightSelectedSeat>;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  seatSelectionDigest?: string;
  /**
   * Selected seats are a draft. The displayed previous fare is not a final all-in price; check the selected card price before consent or purchase.
   * @type {boolean}
   * @memberof FlightBookingHandoffQuote
   */
  seatPricingRequired?: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  quoteId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  provider: FlightBookingHandoffQuoteProviderEnum;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  status: FlightBookingHandoffQuoteStatusEnum;
  /**
   *
   * @type {number}
   * @memberof FlightBookingHandoffQuote
   */
  totalAmount: number;
  /**
   *
   * @type {number}
   * @memberof FlightBookingHandoffQuote
   */
  taxAmount?: number | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  currency: string;
  /**
   *
   * @type {number}
   * @memberof FlightBookingHandoffQuote
   */
  priceDelta?: number | null;
  /**
   *
   * @type {Set<string>}
   * @memberof FlightBookingHandoffQuote
   */
  reconfirmationReasons: Set<string>;
  /**
   *
   * @type {Date}
   * @memberof FlightBookingHandoffQuote
   */
  expiresAt: Date;
  /**
   *
   * @type {FlightObservedItinerary}
   * @memberof FlightBookingHandoffQuote
   */
  itinerary?: FlightObservedItinerary | null;
  /**
   *
   * @type {FlightCheckoutFare}
   * @memberof FlightBookingHandoffQuote
   */
  fare?: FlightCheckoutFare | null;
  /**
   *
   * @type {FlightCheckoutPrice}
   * @memberof FlightBookingHandoffQuote
   */
  price?: FlightCheckoutPrice | null;
  /**
   *
   * @type {FlightPassengerComposition}
   * @memberof FlightBookingHandoffQuote
   */
  passengers?: FlightPassengerComposition | null;
  /**
   *
   * @type {Set<FlightTravelerRequiredField>}
   * @memberof FlightBookingHandoffQuote
   */
  requiredTravelerFields?: Set<FlightTravelerRequiredField>;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  consentVersion?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffQuote
   */
  consentDigest?: string | null;
  /**
   *
   * @type {FlightCommercialQuoteEvidence}
   * @memberof FlightBookingHandoffQuote
   */
  commercialEvidence?: FlightCommercialQuoteEvidence | null;
  /**
   *
   * @type {FlightCheckoutDisclosure}
   * @memberof FlightBookingHandoffQuote
   */
  disclosure?: FlightCheckoutDisclosure | null;
}

/**
 * @export
 */
export const FlightBookingHandoffQuoteProviderEnum = {
  Duffel: "duffel",
  Travelport: "travelport",
} as const;
export type FlightBookingHandoffQuoteProviderEnum =
  (typeof FlightBookingHandoffQuoteProviderEnum)[keyof typeof FlightBookingHandoffQuoteProviderEnum];

/**
 * @export
 */
export const FlightBookingHandoffQuoteStatusEnum = {
  Active: "active",
  ReconfirmationRequired: "reconfirmation_required",
  Confirmed: "confirmed",
  BookingPending: "booking_pending",
  Expired: "expired",
} as const;
export type FlightBookingHandoffQuoteStatusEnum =
  (typeof FlightBookingHandoffQuoteStatusEnum)[keyof typeof FlightBookingHandoffQuoteStatusEnum];

/**
 * Check if a given object implements the FlightBookingHandoffQuote interface.
 */
export function instanceOfFlightBookingHandoffQuote(
  value: object
): value is FlightBookingHandoffQuote {
  if (!("quoteId" in value) || value["quoteId"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("totalAmount" in value) || value["totalAmount"] === undefined)
    return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (
    !("reconfirmationReasons" in value) ||
    value["reconfirmationReasons"] === undefined
  )
    return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  return true;
}

export function FlightBookingHandoffQuoteFromJSON(
  json: any
): FlightBookingHandoffQuote {
  return FlightBookingHandoffQuoteFromJSONTyped(json, false);
}

export function FlightBookingHandoffQuoteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingHandoffQuote {
  if (json == null) {
    return json;
  }
  return {
    selectedBags:
      json["selected_bags"] == null
        ? undefined
        : (json["selected_bags"] as Array<any>).map(FlightSelectedBagFromJSON),
    bagSelectionDigest:
      json["bag_selection_digest"] == null
        ? undefined
        : json["bag_selection_digest"],
    bagPricingRequired:
      json["bag_pricing_required"] == null
        ? undefined
        : json["bag_pricing_required"],
    selectedSeats:
      json["selected_seats"] == null
        ? undefined
        : (json["selected_seats"] as Array<any>).map(
            FlightSelectedSeatFromJSON
          ),
    seatSelectionDigest:
      json["seat_selection_digest"] == null
        ? undefined
        : json["seat_selection_digest"],
    seatPricingRequired:
      json["seat_pricing_required"] == null
        ? undefined
        : json["seat_pricing_required"],
    quoteId: json["quote_id"],
    provider: json["provider"],
    status: json["status"],
    totalAmount: json["total_amount"],
    taxAmount: json["tax_amount"] == null ? undefined : json["tax_amount"],
    currency: json["currency"],
    priceDelta: json["price_delta"] == null ? undefined : json["price_delta"],
    reconfirmationReasons: new Set(json["reconfirmation_reasons"]),
    expiresAt: new Date(json["expires_at"]),
    itinerary:
      json["itinerary"] == null
        ? undefined
        : FlightObservedItineraryFromJSON(json["itinerary"]),
    fare:
      json["fare"] == null
        ? undefined
        : FlightCheckoutFareFromJSON(json["fare"]),
    price:
      json["price"] == null
        ? undefined
        : FlightCheckoutPriceFromJSON(json["price"]),
    passengers:
      json["passengers"] == null
        ? undefined
        : FlightPassengerCompositionFromJSON(json["passengers"]),
    requiredTravelerFields:
      json["required_traveler_fields"] == null
        ? undefined
        : new Set(
            (json["required_traveler_fields"] as Array<any>).map(
              FlightTravelerRequiredFieldFromJSON
            )
          ),
    consentVersion:
      json["consent_version"] == null ? undefined : json["consent_version"],
    consentDigest:
      json["consent_digest"] == null ? undefined : json["consent_digest"],
    commercialEvidence:
      json["commercial_evidence"] == null
        ? undefined
        : FlightCommercialQuoteEvidenceFromJSON(json["commercial_evidence"]),
    disclosure:
      json["disclosure"] == null
        ? undefined
        : FlightCheckoutDisclosureFromJSON(json["disclosure"]),
  };
}

export function FlightBookingHandoffQuoteToJSON(
  json: any
): FlightBookingHandoffQuote {
  return FlightBookingHandoffQuoteToJSONTyped(json, false);
}

export function FlightBookingHandoffQuoteToJSONTyped(
  value?: FlightBookingHandoffQuote | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selected_bags:
      value["selectedBags"] == null
        ? undefined
        : (value["selectedBags"] as Array<any>).map(FlightSelectedBagToJSON),
    bag_selection_digest: value["bagSelectionDigest"],
    bag_pricing_required: value["bagPricingRequired"],
    selected_seats:
      value["selectedSeats"] == null
        ? undefined
        : (value["selectedSeats"] as Array<any>).map(FlightSelectedSeatToJSON),
    seat_selection_digest: value["seatSelectionDigest"],
    seat_pricing_required: value["seatPricingRequired"],
    quote_id: value["quoteId"],
    provider: value["provider"],
    status: value["status"],
    total_amount: value["totalAmount"],
    tax_amount: value["taxAmount"],
    currency: value["currency"],
    price_delta: value["priceDelta"],
    reconfirmation_reasons: Array.from(
      value["reconfirmationReasons"] as Set<any>
    ),
    expires_at: value["expiresAt"].toISOString(),
    itinerary: FlightObservedItineraryToJSON(value["itinerary"]),
    fare: FlightCheckoutFareToJSON(value["fare"]),
    price: FlightCheckoutPriceToJSON(value["price"]),
    passengers: FlightPassengerCompositionToJSON(value["passengers"]),
    required_traveler_fields:
      value["requiredTravelerFields"] == null
        ? undefined
        : Array.from(value["requiredTravelerFields"] as Set<any>).map(
            FlightTravelerRequiredFieldToJSON
          ),
    consent_version: value["consentVersion"],
    consent_digest: value["consentDigest"],
    commercial_evidence: FlightCommercialQuoteEvidenceToJSON(
      value["commercialEvidence"]
    ),
    disclosure: FlightCheckoutDisclosureToJSON(value["disclosure"]),
  };
}
